import commonNav from '@/components/common-nav/index.vue';
//import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
import common from "@/util/common";
const sroreName = {
	result: 'pageDetail',
};
const {
	mapActions
} = createNamespacedHelpers(sroreName.result);
export default {
	data() {
		return {
			name: '',
			money: '',
			orderNo: '',
			time: '',
			rechargeId: '',
			param: '',
			page_content: ''
		};
	},
	components: {
		'common-nav': commonNav,
	},
	mounted() {
        window.scrollTo(0, 0);
		this.loadData();
	},
	watch: {
		
	},
	methods: {
		...mapActions({
			getPage: 'getPage'
		}),
		async loadData(){
			const pageId = this.$route.query.id;

			if(pageId){
				const resultData = await this.getPage({
					content: this,
					data: {
						id: pageId
					}
				});
				this.page_content = resultData;
			}
		},
		goBack(){
            common.goBack(this);
        },
		toAskCourse(){

		},
		toApplyCourse(){
			common.jump(this,'apply');
		}
	}
};
